// extracted by css-extract-rspack-plugin
export default {"root":"root-Owx2rG","illustration":"illustration-i9LGra","form":"form-fluGSe","error":"error-ONdZ5p"};